import { faker } from '@faker-js/faker';
import { UpcomingVisit, VisitMethod } from '@qmd-types/visits';
import getProviderFixture from './getProviderFixture';

export default function getUpcomingVisitFixture(
  params?: Partial<UpcomingVisit>,
): UpcomingVisit {
  const provider = getProviderFixture();

  return {
    dateTime: faker.date.soon().toISOString(),
    isCheckedIn: faker.datatype.boolean(),
    intakeForm: {
      intakeFormId: faker.string.uuid(),
      isCompleted: faker.datatype.boolean(),
    },
    lastEvent: {
      dateTime: faker.date.past().toISOString(),
      type: faker.lorem.word(),
    },
    method: faker.helpers.arrayElement([VisitMethod.CALL, VisitMethod.VIDEO]),
    provider,
    video: {
      accessToken: faker.string.uuid(),
      roomName: faker.lorem.word(),
      videoCallId: faker.string.uuid(),
    },
    visitId: faker.string.uuid(),
    visitTypeName: faker.helpers.arrayElement(['Consultation']),
    ...params,
  };
}
